import { Grid } from '@material-ui/core'
import Actions from 'actions'
import PatientDetails from 'components/common/PatientDetails'
import ShareAutochartFeedbackIcon from 'components/common/icons/ShareAutochartFeedbackIcon'
import DownloadChart from 'components/common/icons/autochart/DownloadChart'
import { AsyncStatus } from 'consts'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { trackEvent } from 'utils/analyticsUtils'
import { exportElementToImage } from 'utils/canvasUtils'
import AutochartHeaderButton from './AutochartHeaderButton'

const AutochartHeader = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { patientSM, status, grinScan } = useSelector(state => state.autochartReducer)

  const handleDownloadChart = useCallback(() => {
    trackEvent('Autochart - download chart as image', {
      patientId: patientSM.id
    })

    exportElementToImage({ selector: '#autochart-grid', fileName: `Autochart - ${patientSM.name}.png` })
  }, [patientSM])

  const handleOpenFeedback = useCallback(() => {
    const contextTextParts = []
    contextTextParts.push('Autochart feedback')
    if (patientSM?.name || patientSM?.id) {
      contextTextParts.push(`patient: ${patientSM?.name || patientSM?.id}`)
    }
    if (grinScan?.id) {
      const autochartId = grinScan?.autochart?.id
      contextTextParts.push(`scanId: ${grinScan.id}${autochartId ? `, autochartId: ${autochartId}` : ''}`)
    }

    const contextText = contextTextParts.join(' | ')

    trackEvent('Autochart - feedback opened', {
      patientId: patientSM?.id,
      scanId: grinScan?.id,
      autochartId: grinScan?.autochart?.id
    })

    dispatch(
      Actions.toggleAppFeedbackDialog({
        value: true,
        // Use standard feedback dialog defaults; include helpful context
        displayNote: false,
        contextText
      })
    )
  }, [dispatch, patientSM?.id, patientSM?.name, grinScan?.id, grinScan?.autochart?.id])

  return (
    <Grid container justifyContent="space-between" alignItems="flex-end">
      <Grid item>
        <PatientDetails
          name={patientSM?.name}
          photo={patientSM?.photo}
          program={patientSM?.program}
          isLoading={status === AsyncStatus.Loading}
        />
      </Grid>
      {status === AsyncStatus.Completed && (
        <Grid item>
          <Grid container alignItems="center" spacing={2}>
            <Grid item>
              <AutochartHeaderButton
                icon={<ShareAutochartFeedbackIcon />}
                label={t('common.appMenu.submitFeedback')}
                onClick={handleOpenFeedback}
              />
            </Grid>
            <Grid item>
              <AutochartHeaderButton
                icon={<DownloadChart />}
                label={t('dialogs.autochart.header.actions.downloadChart')}
                onClick={handleDownloadChart}
              />
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  )
}

export default AutochartHeader
